export type SafeAreaInsets = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

export type AndroidVendor = "samsung" | "xiaomi" | "google" | "other";
export type SafeAreaMode = "dynamic" | "fixed";

export const SAFE_AREA_CACHE_KEY = "tokenseek.safeAreaInsetsCache.v1";
export const SAFE_AREA_CACHE_MAX_AGE_MS = 1000 * 60 * 60 * 24 * 14; // 14 天
export const SAFE_AREA_MODE_UA_TOKEN = "EdgenSafeAreaMode/";

export const IOS_DEFAULT_SAFE_AREA_INSETS: SafeAreaInsets = {
  top: 44,
  right: 0,
  bottom: 34,
  left: 0,
};

export function getAndroidVendorFromUA(ua: string): AndroidVendor {
  const s = (ua || "").toLowerCase();
  if (!s) {
    return "other";
  }

  if (/\bpixel\b/.test(s)) {
    return "google";
  }
  // Samsung：SM- / Samsung / GT- 等型号前缀较常见
  if (/\bsm-|\bsamsung\b|\bgt-|\bsch-|\bscv-|\bshv-/.test(s)) {
    return "samsung";
  }
  if (
    /\bxiaomi\b|\bmiui\b|\bredmi\b|\bpoco\b|\bmi\s|\bm\d{4}[a-z0-9]{0,3}\b/.test(
      s,
    )
  ) {
    return "xiaomi";
  }
  return "other";
}

export function getSafeAreaModeFromUA(ua: string): SafeAreaMode {
  const match = (ua || "").match(/\bEdgenSafeAreaMode\/(fixed|dynamic)\b/i);
  const mode = (match?.[1] || "").toLowerCase();
  return mode === "fixed" ? "fixed" : "dynamic";
}

export function getDefaultAndroidSafeAreaInsetsByVendor(
  vendor: AndroidVendor,
): SafeAreaInsets {
  const top = vendor === "samsung" ? 28 : vendor === "xiaomi" ? 27 : 24;
  const bottom = 16;
  return { top, right: 0, bottom, left: 0 };
}

export function getFixedAndroidSafeAreaInsetsByVendor(
  _vendor: AndroidVendor,
): SafeAreaInsets {
  // fixed 模式用于“稳定优先”场景，可独立于 dynamic 默认值做微调
  const top = 0;
  const bottom = 16;
  return { top, right: 0, bottom, left: 0 };
}

/**
 * 移动端根布局（RootLayoutClient / MobileLayout）是否应用 `pt-safe`。
 * 与桥接里 `mergeFeaturesWithOptimistic` 对齐：仅当原生**显式** `immersiveNavbar === false`
 *（老版本 App、由系统处理安全区）时不加；`true` 与 `undefined`（未声明）均默认加。
 * 沉浸式路由由页面自理，根布局不加。
 */
export function shouldApplyMobileRootSafeAreaTop(
  immersiveNavbar: boolean | undefined,
  isImmersiveRoute: boolean,
): boolean {
  if (isImmersiveRoute) {
    return false;
  }
  return immersiveNavbar !== false;
}
